import React from "react";
import { createRoot } from "react-dom/client";
import { ProjectProvider } from "./context";
import ProjectDataRoot from "./root";

const ProjectDataApp = ({ project, user }) => (
    <ProjectProvider project={project} user={user}>
        <ProjectDataRoot />
    </ProjectProvider>
);

const container = document.getElementById("gp-member-project-root");
if (container) {
    const root = createRoot(container);
    const project = container.dataset.project
        ? container.dataset.project
        : null;
    const user = container.dataset.userid ? container.dataset.userid : null;
    root.render(<ProjectDataApp project={project} user={user} />);
}
